export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/identity.js
// module id = ../../../../d3-shape/src/identity.js
// module chunks = 4